import { render, staticRenderFns } from "./vendor-details-others.vue?vue&type=template&id=64b7aa6a&scoped=true"
import script from "./vendor-details-others.vue?vue&type=script&lang=js"
export * from "./vendor-details-others.vue?vue&type=script&lang=js"
import style0 from "./vendor-details-others.vue?vue&type=style&index=0&id=64b7aa6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b7aa6a",
  null
  
)

export default component.exports